import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../layout/theme-next';
import { NextTheme } from '../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  gridContainer: {
    margin: theme.spacing(3, 1.2, 2),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',

    '& > div': {
      marginBottom: 0,
    },
  },
  textArea: {
    width: 80,
    height: 35,
    marginRight: theme.spacing(0.5),
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  disabledGrid: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  marginBottom: {
    marginBottom: theme.spacing(4),
  },
  title: {
    color: Colors.textBlack,
    marginBottom: theme.spacing(0.25),
    fontWeight: 600,
    fontSize: 14,
  },
  description: {
    color: Colors.textGray,
    fontSize: 12,
  },
  gracePeriodContainer: {
    borderTop: `1px solid ${Colors.stroke}`,
    paddingTop: theme.spacing(2),
  },
  gracePeriodDescription: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));
